export default __webpack_public_path__ + "static/media/050_brake.last.bf0c9d58.avif";